import { AuditBotPromiseClient } from '@trustero/trustero-api-web/lib/audit/auditbot_grpc_web_pb'
import {
  ControlPolicyMatchDetails,
  GetControlPolicyMatchDetailsRequest,
  GetOperatingEffectivenessDetailsRequest,
  OperatingEffectivenessDetails,
} from '@trustero/trustero-api-web/lib/audit/auditbot_pb'
import { GrpcResponse, NewGrpcResponse } from 'src/components/async/hooks/types'
import { useSwrImmutableGrpc } from 'src/components/async/useSwrImmutableGrpc'

export const useControlPolicyMatchDetails = (
  id: string,
  shouldFetch = false,
): GrpcResponse<ControlPolicyMatchDetails> => {
  const request = new GetControlPolicyMatchDetailsRequest().setControlTestId(id)
  const { response } = useSwrImmutableGrpc(
    AuditBotPromiseClient.prototype.getControlPolicyMatchDetails,
    request,
    shouldFetch,
  )
  return NewGrpcResponse(response)
}

export const useOperatingEffectivenessDetails = (
  id: string,
  shouldFetch = false,
): GrpcResponse<OperatingEffectivenessDetails> => {
  const request =
    new GetOperatingEffectivenessDetailsRequest().setControlTestId(id)
  const { response } = useSwrImmutableGrpc(
    AuditBotPromiseClient.prototype.getOperatingEffectivenessDetails,
    request,
    shouldFetch,
  )
  return NewGrpcResponse(response)
}
